import { DateTime } from 'luxon'
import { DailyHours } from '@leverege/operating-hours'
import Constants from './Constants'

export { default as Constants } from './Constants'
export * from './Bays'
export * from './Format'

const HOURS_FORMATS = 'hh:mma'
const DAYS = [ 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday' ]

/**
 * 
 * @param {object} hours 
 * @param {import('luxon').DateTime} baseDate 
 * @returns 
 */
export function getOpenAndCloseTimesFromHours( hours, baseDate, timezone ) {
  const ranges = DailyHours.getRanges( hours )
  
  if ( ranges?.length > 0 ) {
    const { start, end } = ranges[0]
    const startDate = DateTime.fromFormat(
      start,
      HOURS_FORMATS,
      { zone : timezone }
    )
      .set( {
        day : baseDate.day,
        month : baseDate.month,
        year : baseDate.year
      } )
    const endDate = DateTime.fromFormat(
      end,
      HOURS_FORMATS,
      { zone : timezone }
    )
      .set( {
        day : baseDate.day,
        month : baseDate.month,
        year : baseDate.year
      } )

    return {
      open : startDate,
      close : endDate
    }
  }

  return {}
}

export function getBusinessDays( range, operatingHours, opts ) {
  const { getFullRange = false } = opts || {}
  const { start, end } = range

  const days = []

  const { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone } = operatingHours || {}

  let sLocal = DateTime.fromJSDate( start, { zone : timezone } ).set( { day : start.getDate() } ).startOf( 'day' )
  const eLocal = DateTime.fromJSDate( end, { zone : timezone } ).set( { day : end.getDate() } ).endOf( 'day' )

  const now = Date.now()
  while ( sLocal < eLocal ) {

    const startOfWorkDay = sLocal.startOf( 'day' )
    const endOfWorkDay = sLocal.endOf( 'day' )
  
    days.push(
      [ startOfWorkDay.valueOf(), ( !getFullRange && endOfWorkDay.valueOf() > now ) ? now : endOfWorkDay.valueOf() ]
    )

    sLocal = sLocal.plus( { days : 1 } )
  }

  return days
}

export function getOpenHoursFromOperatingHours( operatingHours ) {
  const timezone = operatingHours?.timezone
  const mode = operatingHours?.modes[operatingHours?.currentMode]

  if ( !mode ) {
    return []
  }

  let minHour
  let maxHour

  DAYS.forEach( ( day ) => {
    if ( mode[day].open ) {
      const { start, end } = getStartAndEndTimeFromRanges( mode[day].ranges, timezone )

      if ( !minHour || start < minHour ) {
        minHour = start.toLocal()
      }

      if ( !maxHour || end > maxHour ) {
        maxHour = end.toLocal()
      }
    }
  } )

  const startHour = minHour.get( 'hour' )
  const endHour = maxHour.get( 'hour' )

  const hours = []

  for ( let i = startHour; i <= endHour; i++ ) {
    hours.push( `${i}` )
  }

  return hours
}

function getStartAndEndTimeFromRanges( ranges = [], timezone = 'America/Phoenix', padHours = 0 ) {
  let start
  let end

  ranges.forEach( ( range ) => {
    const { start : rStart, end : rEnd } = range

    const startTime = DateTime
      .fromFormat( rStart, HOURS_FORMATS, { zone : timezone } )
      .minus( { hours : padHours } )
    const endTime = DateTime
      .fromFormat( rEnd, HOURS_FORMATS, { zone : timezone } )
      .plus( { hours : padHours } )

    if ( !start || startTime < start ) {
      start = startTime
    }

    if ( !end || endTime > end ) {
      end = endTime
    }
  } )

  return { start, end }
}
